import React from 'react';

import cx from 'classnames';
import { useDispatch } from 'react-redux';

import { MODAL_TYPE } from 'constants/modalTypes';
import { setTermsOfServiceModalOpenAction } from 'store/terms_of_use';

import CheckBox from '../../FormAdapters/FormDefault/CheckBox';
import s from '../index.module.css';

interface ILocalLegalInfoProps {
  isChecked: boolean;
  toggleCheckbox: () => void;
}

const LocalLegalInfo: React.FC<ILocalLegalInfoProps> = ({ isChecked, toggleCheckbox }) => {
  const dispatch = useDispatch();

  return (
    <div className={cx(s.termsandconds, 'custom-auth-terms-and-cons')}>
      <CheckBox
        checked={isChecked}
        onChange={toggleCheckbox}
        noMargin
        size="sm"
        className={s.guestAgreeTermsCheckbox}
      />
      <span>
        I agree to accept the{' '}
        <span className="link" onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.TERMS_OF_SERVICE))}>
          Terms of Service
        </span>
        {' and '}
        <span className="link" onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.PRIVACY_POLICY))}>
          Privacy Policy.
        </span>
      </span>
    </div>
  );
};

export default LocalLegalInfo;
